/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Restart_NoticeInputs */

const en_options_backup_restart_notice = /** @type {(inputs: Options_Backup_Restart_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please restart the application for changes to take effect.`)
};

const fr_options_backup_restart_notice = /** @type {(inputs: Options_Backup_Restart_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez redémarrer l'application pour que les changements prennent effet.`)
};

const de_options_backup_restart_notice = /** @type {(inputs: Options_Backup_Restart_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte starten Sie die Anwendung neu, damit die Änderungen wirksam werden.`)
};

const it_options_backup_restart_notice = /** @type {(inputs: Options_Backup_Restart_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riavviare l'applicazione affinché le modifiche abbiano effetto.`)
};

const ru_options_backup_restart_notice = /** @type {(inputs: Options_Backup_Restart_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для вступления изменений в силу, пожалуйста, перезапустите приложение.`)
};

const es_options_backup_restart_notice = /** @type {(inputs: Options_Backup_Restart_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reinicie la aplicación para que los cambios surtan efecto.`)
};

const zh_cn2_options_backup_restart_notice = /** @type {(inputs: Options_Backup_Restart_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请重启应用程序以使更改生效。`)
};

const ja_options_backup_restart_notice = /** @type {(inputs: Options_Backup_Restart_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更を有効にするには、アプリケーションを再起動してください。`)
};

const hi_options_backup_restart_notice = /** @type {(inputs: Options_Backup_Restart_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तनों को प्रभावी होने के लिए कृपया एप्लिकेशन को पुनः आरंभ करें।`)
};

const pt_pt2_options_backup_restart_notice = /** @type {(inputs: Options_Backup_Restart_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reinicie o aplicativo para que as alterações entrem em vigor.`)
};

/**
* | output |
* | --- |
* | "Please restart the application for changes to take effect." |
*
* @param {Options_Backup_Restart_NoticeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_restart_notice = /** @type {((inputs?: Options_Backup_Restart_NoticeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Restart_NoticeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_restart_notice(inputs)
	if (locale === "de") return de_options_backup_restart_notice(inputs)
	if (locale === "it") return it_options_backup_restart_notice(inputs)
	if (locale === "ru") return ru_options_backup_restart_notice(inputs)
	if (locale === "es") return es_options_backup_restart_notice(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_restart_notice(inputs)
	if (locale === "ja") return ja_options_backup_restart_notice(inputs)
	if (locale === "hi") return hi_options_backup_restart_notice(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_restart_notice(inputs)
	return en_options_backup_restart_notice(inputs)
});